<template>
    <div>
        <el-form  ref="lineForm" :model="lineList" label-width="110px" size="mini">
            <el-form-item prop="no" class="lable-width" :label="$t('form_serial_number')">
                <el-input class="input-width" placeholder="请输入产线序号" clearable v-model="lineList.no"></el-input>
            </el-form-item>
            <el-form-item prop="name" class="lable-width" label="产线名">
                <el-input class="input-width" placeholder="请输入产线名" clearable v-model="lineList.name"></el-input>
            </el-form-item>
            <el-form-item prop="workSection" class="lable-width" label="工段">
                <el-input class="input-width" placeholder="请输入工段" clearable v-model="lineList.workSection"></el-input>
            </el-form-item>
            <el-form-item prop="product" class="lable-width" label="产品">
                <el-input class="input-width" placeholder="请输入产品" clearable v-model="lineList.product"></el-input>
            </el-form-item>
            <el-form-item prop="state" class="lable-width" label="状态">
                <el-select clearable class="input-width"  v-model="lineList.state" filterable placeholder="请选择">
                    <el-option
                            v-for="item in stateList"
                            :key="item.id"
                            :label="item.v"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="createPreson" class="lable-width" label="录入人">
                <el-input class="input-width" placeholder="请输入录入人姓名" clearable v-model="lineList.createPreson"></el-input>
            </el-form-item>
            <el-form-item prop="createTime" class="lable-width" label="录入时间">
                <el-date-picker
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        class="input-width"
                        v-model="lineList.createTime"
                        type="date"
                        placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item class="lable-width" style="margin-left: 0">
                <el-button style="margin-left: 0" type="primary" @click="onSubmit">{{$t('button_save')}}</el-button>
                <el-button type="primary" @click="close">取消</el-button>
            </el-form-item>
        </el-form>

    </div>
</template>

<script>
    //import * as API from "../api";
    import {mapActions} from "vuex";
    export default {
        name: 'reviseTemplate',
        props:{
            title:{
              type:String
            },
            lineList:{
              type:Object
            },
            listid:{
              type:Number
            },
            editData:{
                type:Object
            }
        },
        data(){
            return{
                stateList:[{
                    id:1,
                    v:'运行中'
                },{
                    id:2,
                    v:'调整中'
                },{
                    id:3,
                    v:'停机'
                },],
                cf:'',
                cffb:false,
                jgsc:'',
                gwcgdata:999,
                bmdata:[],
                cjdata:[],
                bzdata:[],
                value:'',
                weekdate:'',
                // gwdata:[],
                // stationdata:[],
                monthdate:'',
                positionopen:0,
                nfcopen:0,

                monthData:[],
                consumername:[],
                datatimes:[],
                templateData:[],
                cjpanduan:0,
                bzpanduan:0,

            }
        },
        watch:{
        },
        mounted(){
            // if(this.editData.id!==0){
            //   this.dcsdetail()
            // }
        },
        methods:{
            nfcfocus(){
                this.nfcopen=1
            },
            positionfocus(){
                this.positionopen=1

            },
            nfcblur(){
                this.nfcopen=0
            },
            positionblur(){
                this.positionopen=0
            },
            timepick(val){
                if(val==null){
                    this.editData.beginTime=''
                }
            },
            cycleselect(val){
                this.editData.cycle=val

                // if(val==''){
                this.editData.beginTime=''
                // }
                this.monthdate=''
                this.weekdate=''
                // console.log(this.datatimes)
            },
            radiojudge(val){

            },
            localradio(val){
                // console.log(val)
                this.editData.nfc=val
                // this.tishi=1
            },
            ...mapActions(["getCurrentMenuId"]),

            //部门


            //岗位


            //模板

            //业务配置保存
            async dcssave() {
                // if(this.editData.nfc==''){
                //     this.$message({
                //         message: '请输入nfc编号',
                //         type: 'error'
                //     });
                //     return
                // }
                // if(this.editData.no==''){
                //     this.$message({
                //         message: '请输入设备编号',
                //         type: 'error'
                //     });
                //     return
                // }
                // if(this.editData.type==''){
                //     this.$message({
                //         message: '请选择设备类型',
                //         type: 'error'
                //     });
                //     return
                // }
                // if(this.editData.name==''){
                //     this.$message({
                //         message: '请输入设备名',
                //         type: 'error'
                //     });
                //     return
                // }
                // if(this.editData.dcsNo==''){
                //     this.$message({
                //         message: '请输入dcs编号',
                //         type: 'error'
                //     });
                //     return
                // }
                // console.log(this.editData.moneyBuy=='')
                // if(this.editData.moneyBuy==''){
                //     this.$message({
                //         message: '请输入购买金额',
                //         type: 'error'
                //     });
                //     return
                // }
                // if(this.editData.inspectionTime==''||this.editData.inspectionTime==null){
                //     this.$message({
                //         message: '请选择巡检时间',
                //         type: 'error'
                //     });
                //     return
                // }
                // if(this.editData.buyTime==''||this.editData.buyTime==null){
                //     this.$message({
                //         message: '请选择采购时间',
                //         type: 'error'
                //     });
                //     return
                // }
                // if(this.editData.regisTime==''||this.editData.regisTime==null){
                //     this.$message({
                //         message: '请选择登记时间',
                //         type: 'error'
                //     });
                //     return
                // }
                // if(this.editData.guaranteeTime==''||this.editData.guaranteeTime==null){
                //     this.$message({
                //         message: '请选择保修时间',
                //         type: 'error'
                //     });
                //     return
                // }
                // return
                if(this.editData.isDcs==0){
                    this.editData.dcsNo=''
                }
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.editData.id,
                    nfc:this.editData.nfc,
                    no:this.editData.no,
                    type:this.editData.type,
                    name:this.editData.name,
                    dcsNo:this.editData.dcsNo,
                    position:this.editData.position,
                    calculationFormula:this.editData.calculationFormula,
                    inspectionPeriod:this.editData.inspectionPeriod,
                    inspectionTime:this.editData.inspectionTime,
                    buyTime:this.editData.buyTime,
                    regisTime:this.editData.regisTime,
                    guaranteeTime:this.editData.guaranteeTime,
                    moneyBuy:this.editData.moneyBuy,
                    personLiableId:this.editData.personLiableId,
                    orderNo:this.editData.orderNo,
                    description:this.editData.description,
                    // isNfc:1,
                    isDcs:this.editData.isDcs,
                    state:this.editData.state
                }
                for(let i in params){
                    if(params[i]===''){
                        delete params[i]
                    }
                }
                // console.log(params)
                // return
                let res = await API.dcssave(params);
                if (res.code == 1) {
                    this.$emit('dcslist')
                    // if(this.listid==this.editData.id){
                        this.$emit('clist')

                    // }
                    // console.log(this.listid)
                    this.$emit('close')
                    this.$message({
                        message: res.message,
                        type: 'success'
                    });

                } else if (res.code == -2) {

                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else if (res.code == -1){
                    this.editData.beginTime=''
                    this.$message({
                        message:res.message,
                        type:'warning'
                    })
                }else {
                    this.editData.beginTime=''
                    this.$message.error(res.message);

                }
            },

            close(){
                this.$emit('close')
            },

            onSubmit(){
                    this.$emit('lineList', this.lineList)
//获取对应ID
//                 this.$refs.ruleForm.validate((valid) => {
//                     if (valid) {
//                         // console.log(this.editData.xfname)
//
//                         // let add1=this.consumername.filter(item=>{
//                         //     return  item.name==this.editData.consumerName
//                         // })
//                         // console.log(add1)
//                         // this.editData.consumerId=add1[0].id
//                         this.dcssave()
//                     } else {
//                         // console.log('error submit!!');
//                         return false;
//                     }
//                 });


            },

        }
    }
</script>
<style lang="scss" scoped>
    /deep/{
        .lable-width .el-form-item__content{
            margin-left: 0 !important;
        }
        .el-textarea__inner{
            height: 100px !important;
            color: #000000 !important;
            /*font-weight: 600 !important;*/
            font-size: inherit !important;
        }
        .el-form-item__error{
            left: 50% !important;
        }
    }
    .lable-width{
        text-align: center;
    }
    .slable-width{

    }
    .dialog-footer{
        display: flex;
        justify-content: center;
        align-items: center;
        /*text-align: center;*/
        margin-top: 12px;
    }
    .input-width{
        /*text-align: center;*/
        width: 18.571rem;
    }
    .sinput-width{
        width: 150px;
        margin-left: 28px;
    }
    /deep/.json .el-textarea__inner{
        height: 180px !important;
    }
    /deep/.describe .el-textarea__inner{
        height: 80px !important;

    }
</style>